import { render, staticRenderFns } from "./ElectronicInvoice.vue?vue&type=template&id=ad224e80&scoped=true&"
import script from "./ElectronicInvoice.vue?vue&type=script&lang=js&"
export * from "./ElectronicInvoice.vue?vue&type=script&lang=js&"
import style0 from "./ElectronicInvoice.vue?vue&type=style&index=0&id=ad224e80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad224e80",
  null
  
)

export default component.exports